import responseConfig, { AlmeResponseConfig } from "../AlmeResponse/AlmeResponseConfig";
import scrollButtonConfig, { AlmeScrollButtonConfig } from "../AlmeScrollButton/AlmeScrollButtonConfig";
import timeoutConfig, { AlmeTimeoutWarningConfig } from "../AlmeTimeoutWarning/AlmeTimeoutWarningConfig";
import liveChatResponseConfig, { AlmeLiveChatResponseConfig } from "../LiveChat/AlmeLiveChatResponse/AlmeLiveChatResponseConfig";

export interface HistoryConfig extends AlmeResponseConfig, AlmeScrollButtonConfig,
    AlmeLiveChatResponseConfig, AlmeTimeoutWarningConfig {
    shouldScrollOnNav?: boolean;
}
export interface AlmeHistoryConfig {
    history: HistoryConfig;
}

/**
 * This is the baseline history config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeHistoryConfig = {
    history: {
        ...responseConfig,
        ...scrollButtonConfig,
        ...liveChatResponseConfig,
        ...timeoutConfig,
        shouldScrollOnNav: true,
    },
};

export default defaultConfig;